import { Navigate, useSearchParams } from "react-router-dom";
import { SiteView } from "../components/Infrastructure/Site";
import { EmissionFormSidePanel } from "../components/Infrastructure/Site/EmissionFormSidePanel";
import { ROUTES } from "./index";
import { PermissionGate } from "./PermissionGate";

export const InfrastructureSitePage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const site = searchParams.get("site");
    const eventForm = searchParams.get("eventForm");

    if (!site) {
        return <Navigate to={ROUTES.INFRASTRUCURE} replace />;
    }

    return (
        <PermissionGate permission="infrastructureView">
            <div className="h-screen overflow-auto w-full flex mb-2">
                <SiteView siteId={site} />
                {eventForm && (
                    <EmissionFormSidePanel
                        emissionId={eventForm}
                        onClose={() =>
                            setSearchParams((prev) => {
                                prev.delete("eventForm");
                                return prev;
                            })
                        }
                    />
                )}
            </div>
        </PermissionGate>
    );
};
